import { propEq } from 'ramda'
import React from 'react'

import { useCalendar } from './CalendarHandler'
import ButtonPicker from '../form/ButtonPicker'

const PERSPECTIVE_OPTIONS = [
  { id: 'month', name: 'Mês' },
  { id: 'week', name: 'Semana' },
  { id: 'day', name: 'Dia' }
]

const CalendarPerspectivePicker = () => {
  const { perspective, onSelectPerspective } = useCalendar()

  return (
    <ButtonPicker
      inPanel
      _label={PERSPECTIVE_OPTIONS.find(propEq('id', perspective))?.name}
      value={perspective}
      options={PERSPECTIVE_OPTIONS}
      onChange={item => onSelectPerspective(item.id)}
      size="xsmall"
      bold
    />
  )
}

export default CalendarPerspectivePicker
